import React from 'react';
import ChatsWhatsappPage from './ChatsWhatsappPage';

const ChatsSolicitaPage = (props) => <ChatsWhatsappPage {...props} chatTipo="solicita" />;

export default ChatsSolicitaPage;
